var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2673 19.7931C12.9674 20.0788 12.4926 20.0672 12.2069 19.7673C11.9212 19.4674 11.9328 18.9926 12.2327 18.7069L18.4841 12.7524L3.75 12.7524C3.33579 12.7524 3 12.4166 3 12.0024C3 11.5882 3.33579 11.2524 3.75 11.2524L18.4842 11.2524L12.2327 5.29765C11.9328 5.01195 11.9212 4.53715 12.2069 4.23725C12.4926 3.93735 12.9674 3.92575 13.2673 4.21145L20.6862 11.2782C20.8551 11.4391 20.9551 11.6444 20.9861 11.8577C20.9952 11.9045 21 11.9529 21 12.0024C21 12.0519 20.9952 12.1004 20.986 12.1473C20.955 12.3605 20.855 12.5656 20.6862 12.7264L13.2673 19.7931Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.a9a16408931027d0e073ee6f00306938.svg";
export { ForwardRef as ReactComponent };